import { configureStore } from "@reduxjs/toolkit";
import youtubeReducer from "../slices/youtubeSlice";
import analyticsReducer from "../slices/videoPerformanceSlice";
import toggleSidebarReducer from "../slices/toggleSidebarSlice";
import toggleTableReducer from "../slices/toggleTableSlice";
import authReducer from "../slices/loginSlice";
import versionControlReducer from "../slices/versionControlSlice";
import userSettingsReducer from "../slices/UserSettingsSlice";
import inviteReducer from "../slices/inviteSlice";
import userProfileReducer from "../slices/userProfileSlice";
import audienceInsightReducer from "../slices/audienceInsightSlice";

const asyncDispatchMiddleware = (store) => (next) => (action) => {
  if (typeof action === "function") {
    return action(store.dispatch, store.getState);
  }
  return next(action);
};

export const store = configureStore({
  reducer: {
    youtube: youtubeReducer,
    analytics: analyticsReducer,
    toggleTable: toggleTableReducer,
    toggleSidebar: toggleSidebarReducer,
    auth: authReducer,
    versionControl: versionControlReducer,
    userSettings: userSettingsReducer,
    invites: inviteReducer,
    userProfile: userProfileReducer,
    audienceInsight: audienceInsightReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(asyncDispatchMiddleware),
});

export default store;
